const ACTIVE_OR_DONE_STATUSES = new Set([
  "in_progress",
  "started",
  "attempted",
  "markscalculated",
  "missed",
  "submitted",
]);

export function shouldShowGeniusStartingSoon(
  examStatus: string,
  startTime?: string,
  endTime?: string,
): boolean {
  const status = examStatus.trim().toLowerCase();
  if (ACTIVE_OR_DONE_STATUSES.has(status)) return false;

  const startMs = startTime ? new Date(startTime).getTime() : Number.NaN;
  if (!Number.isNaN(startMs)) {
    return startMs > Date.now();
  }

  if (
    status === "coming_up" ||
    status === "upcoming" ||
    status === "scheduled"
  ) {
    return true;
  }

  const endMs = endTime ? new Date(endTime).getTime() : Number.NaN;
  return (
    !Number.isNaN(endMs) && endMs > Date.now() && status === "not_attempted"
  );
}
